app.controller("DicomViewerController", [
	"$scope",
	"$window",
	"$state",
	"Session",
	"CurrentPatient",
	function ($scope, $window, $state, Session, CurrentPatient) {
		$scope.VIEWER_URL = window.location.origin + "/react";
		// $scope.VIEWER_URL = "http://localhost:3030/react/";
		const viewerOrigin = new URL($scope.VIEWER_URL).origin;
		const handler = (event) => {
			// Only the viewer's own frame is listened to - any other window can post here too.
			const iframe = document.getElementById("ohif-app");
			if (event.origin !== viewerOrigin || !iframe || event.source !== iframe.contentWindow) return;
			const data = event.data;
			if (!data || typeof data !== "object") return;

			// A window message arrives outside Angular, so the change is applied in a digest.
			$scope.$evalAsync(() => {
				if (data.type === "ROUTE_CHANGED" && data.path === "/react/") {
					$state.go("patient-dashboard");
				} else if (data.type === "ENTER_FULLSCREEN") {
					$scope.isFullScreen = true;
				} else if (data.type === "EXIT_FULLSCREEN") {
					$scope.isFullScreen = false;
				}
			});
		};

		this.$onInit = function () {
			$scope.isFullScreen = false;
			const iframe = document.getElementById("ohif-app");
			iframe.onload = () => {
				$window.addEventListener("message", handler);
				setTimeout(() => {
					const iframe = document.getElementById("ohif-app");
					iframe.contentWindow.postMessage(
						{
							type: "SET_PATIENT_PRACTICE",
							data: {
								practiceId: `${Session.practice.id}`,
								patientId: `${CurrentPatient.patient.id}`,
							},
						},
						$scope.VIEWER_URL,
					);
				}, 1000);
			};
		};

		$scope.toggleFullScreen = function () {
			$scope.isFullScreen = !$scope.isFullScreen;
		}

		$scope.$on("$destroy", () => {
			$window.removeEventListener("message", handler);
		});
	},
]);
